<template>
	<!-- Modal -->
	<div class="modal fade" id="modal-view-comments" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <div class="modal-header no-padding-bottom">
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	        <h2 class="text-uppercase no-margin">Ver comentarios</h2>
	        <!-- <stars :rating="render_rate"></stars> -->
	        <input type="hidden" class="rating modal-rating" data-filled="fa fa-star item-rate-yellow item-rate" data-empty="fa fa-star item-rate-gray item-rate" data-readonly :value="render_rate"/>
	        <p class="text-gray-sm">Puntuación media: {{ render_rate }} ({{ render_ratings.length }} valoraciones)</p>
	        <p v-if="!render_ratings.length" class="empty">No hay comentarios para este producto.</p>
	      </div>
	      <div class="modal-body">
	      	<div class="row" v-for="rating in render_ratings | mini_pag index per_page">
	      		<div class="col-sm-3">
	      			<p class="text-gray-md">{{ rating.first_name }} {{ rating.last_name }}</p>
	      		</div>
	      		<div class="col-sm-3">
	      			<stars :rating="rating.rating"></stars>
	      		</div>
	      		<div class="col-sm-6">
	      			<p class="text-gray-md">{{ moment(rating.created_at).format('YYYY-MM-DD') }}</p>
	      			<p class="text-gray-md">{{ rating.review }}</p>
	      		</div>
	      	</div>
	      	<div class="row text-right">
	      		<div class="col-sm-11 col-sm-offset-1">
					<button v-if="index > 1" type="button" class="btn btn-black" @click="back">Anterior</button>
					<button v-if="index < Math.ceil(render_ratings.length / per_page)" type="button" class="btn btn-black" @click="next">Siguiente</button>
				</div>
	      	</div>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<style scoped>
	.btn-link{
		color: black;
	}
</style>

<script>
import Stars from '../Product/Product-detail-rate-stars.vue'
import moment from 'moment';

export default {
	props: ['rate', 'ratings'],

	data () {
		return {
			per_page: 4,
			index: 1
		}
	},
	
	components: {
		Stars,
	},

	methods: {
		moment,

		back () {
			this.index--;
		},

		next () {
			this.index++;
		}
	},

	computed: {
		render_rate () {
			if (!this.rate) {
				this.rate = 0
			}

			$('.modal-rating').rating('rate', this.rate)
			return this.rate
		},

		render_ratings () {
			return this.ratings
		}
	}
}
</script>


// WEBPACK FOOTER //
// Modal-view-comments.vue?667e40a2